import React from "react";
import "../../../ReactKaamvalaWebsite/Pages/contact/Contact.css";
import locate from "../../../ReactKaamvalaWebsite/assets/icon/locate.svg";
import email from "../../../ReactKaamvalaWebsite/assets/icon/email_contact.svg";
const Contact = () => {
  return (
    <>
      <div id="Contact-us">
        <section className="contact-us">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="contact-us-section">
                  <div
                    className="contact-us-title text-center justify-content-center
                            m-auto my-4"
                  >
                    <h4>Contact Us</h4>
                  </div>
                  <div className="contact-us-design">
                    <div className="row">
                      <div className="col-md-5 d-flex justify-content-center m-auto">
                        <div className="text-headings">
                          <h4>Kaamvala</h4>
                        </div>
                      </div>
                      <div className="col-md-7 align-items-center m-auto pl-5">
                        <div className="img_cont_box d-flex py-2">
                          <div>
                            <img
                              src={locate}
                              className="d-block image-fluid "
                              width="30"
                              height="32"
                              alt="web and app development"
                            />
                          </div>
                          <p>
                            7th Floor, TOWER-C, Noida One, Unit C-720, Plot No.
                            8, Block B, Noida, Uttar Pradesh 201309
                          </p>
                        </div>
                        <div className="img_cont_box d-flex py-2">
                          <div>
                            <img
                              src={email}
                              className="d-block image-fluid "
                              width="30"
                              height="32"
                              alt="web and app development"
                            />
                          </div>
                          <p>help@kaamvala.com</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="accordion">
          <div className="container my-5">
            <div className="row">
              <div className="col-md-12">
                <div
                  className="accordion faq_accordion"
                  id="accordionExample"
                ></div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
export default Contact;
